(function() {
  function parseEuro(text) {
    text = text.trim().replace(/[^\d,.]/g, '');
    text = text.replace(/\.(?=\d{3})/g, '');
    text = text.replace(',', '.');
    return parseFloat(text);
  }

  function ramoActiveCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
  }

  function ramoActiveLocale(cur) {
    return cur === 'EUR' ? 'it-IT' : cur === 'CHF' ? 'de-CH' : cur === 'CAD' ? 'en-CA' : 'en-US';
  }

  function formatEuro(value) {
    var cur = ramoActiveCurrency();
    return value.toLocaleString(ramoActiveLocale(cur), {
      style: 'currency',
      currency: cur,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function ramoUpdateKlarna() {
    var el = document.getElementById('ramo-klarna-rate');
    if (!el) return;
    var totalEl = document.querySelector('.totals__subtotal-value');
    if (!totalEl) return;
    var total = parseEuro(totalEl.innerText);
    if (!isNaN(total) && total > 0) {
      var rata = formatEuro(total / 12);
      var tot = formatEuro(total);
      el.innerHTML = '<strong>' + rata + '</strong><span class="ramo-klarna-total">' + ramoKlarnaLabel(tot) + '</span>';
    }
  }

  function ramoStartPolling() {
    var attempts = 0;
    var interval = setInterval(function() {
      var el = document.getElementById('ramo-klarna-rate');
      var totalEl = document.querySelector('.totals__subtotal-value');
      if (el && totalEl) {
        ramoUpdateKlarna();
        clearInterval(interval);
      }
      if (++attempts > 30) clearInterval(interval);
    }, 200);
  }

  function ramoObserveSubtotal() {
    var totalEl = document.querySelector('.totals__subtotal-value');
    if (!totalEl) return;
    var observer = new MutationObserver(function() {
      setTimeout(ramoUpdateKlarna, 100);
    });
    observer.observe(totalEl, { childList: true, subtree: true, characterData: true });
  }

  function ramoObserveDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    var observer = new MutationObserver(function() {
      var el = document.getElementById('ramo-klarna-rate');
      if (el) {
        setTimeout(function() {
          ramoUpdateKlarna();
          ramoObserveSubtotal();
        }, 150);
      }
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function() {
    ramoStartPolling();
    ramoObserveDrawer();
  });

  document.addEventListener('cart:refresh', function() { setTimeout(ramoStartPolling, 200); });
  document.addEventListener('cart:updated', function() { setTimeout(ramoStartPolling, 200); });

  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-cart-open], .cart-count-bubble, .header__icon--cart, .quantity__button')) {
      setTimeout(ramoStartPolling, 400);
    }
  });
})();
// === Ramo2: Klarna sulla pagina prodotto ===
function ramoFormatMoney(value) {
  var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
  var loc = cur === 'EUR' ? 'it-IT' : cur === 'CHF' ? 'de-CH' : cur === 'CAD' ? 'en-CA' : 'en-US';
  return value.toLocaleString(loc, {
    style: 'currency',
    currency: cur,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}
function ramoKlarnaLabel(tot) {
  var lang = (document.documentElement.lang || 'it').slice(0, 2).toLowerCase();
  var labels = {
    it: ' × 12 mesi (totale ' + tot + ')',
    en: ' × 12 months (total ' + tot + ')',
    de: ' × 12 Monate (gesamt ' + tot + ')',
    fr: ' × 12 mois (total ' + tot + ')',
    es: ' × 12 meses (total ' + tot + ')'
  };
  return labels[lang] || labels.it;
}
function ramoUpdateProductKlarna() {
  document.querySelectorAll('.ramo-klarna-product').forEach(function(el) {
    var priceRaw = el.getAttribute('data-price');
    var rateEl = el.querySelector('.ramo-klarna-product-rate');
    if (!rateEl || !priceRaw) return;
    var price = parseInt(priceRaw) / 100;
    var qtyInput = document.querySelector('.quantity__input, [name="quantity"], input[type="number"]');
    var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
    if (!isNaN(price) && price > 0) {
      var priceTotal = price * qty;
      var rata = ramoFormatMoney(priceTotal / 12);
      var tot = ramoFormatMoney(priceTotal);
      rateEl.innerHTML = rata + '<span class="ramo-klarna-total">' + ramoKlarnaLabel(tot) + '</span>';
    }
  });
}

document.addEventListener('DOMContentLoaded', ramoUpdateProductKlarna);
setTimeout(ramoUpdateProductKlarna, 500);
document.addEventListener('change', function(e) {
  if (e.target.matches('.quantity__input, [name="quantity"], input[type="number"]')) {
    ramoUpdateProductKlarna();
  }
});
document.addEventListener('click', function(e) {
  if (e.target.closest('.quantity__button, .quantity-button, [data-quantity-plus], [data-quantity-minus]')) {
    setTimeout(ramoUpdateProductKlarna, 50);
  }
});

document.addEventListener('variant:changed', function(e) {
  if (e.detail && e.detail.variant) {
    document.querySelectorAll('.ramo-klarna-product').forEach(function(el) {
      el.setAttribute('data-price', e.detail.variant.price);
    });
    ramoUpdateProductKlarna();
  }
});